const config = {
    baseURL: 'https://e.haazri.net/',
    defaultHeaders: {
        'Content-Type': 'application/json'
    }
};

export default config;
